import { render, staticRenderFns } from "./BaseSelector.vue?vue&type=template&id=7680759c&"
import script from "./BaseSelector.vue?vue&type=script&lang=js&"
export * from "./BaseSelector.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
